import { Button, Checkbox, Dialog, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import { ButtonStyled, DescriptionStyled, DialogContentStyled, InfoFastQuiz, NewInfo, PopupTitle, WrapperActions, WrapperInfo } from "./ShareQuizPopup.styled";
import { useGetAllClassroom } from "../../hooks/useClassroom";
import { useEffect, useState } from "react";
import { useAddQuizToClassroom } from "../../hooks/useQuiz";
import { Spinner } from "../Spinner";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { MAX_LIMIT, QUIZ_TYPE } from "../../utils/constants";

export const ShareQuizPopup = ({ isOpen, onCreatePrivateQuiz, onCreateShareQuiz, onSetIdFastQuiz }) => {
    const { response, isLoading } = useGetAllClassroom();
    const { addQuiz, isAdditing } = useAddQuizToClassroom();

    const navigate = useNavigate();
        
    
    const [classroomList, setClassroomList] = useState([]);
    const [checked, setChecked] = useState([]);

    useEffect(() => { 
        if (response?.classroomList) {
            // const filteredClassroomList = response.classroomList.filter(classroom => classroom.quizList.length < MAX_LIMIT.QUIZ_IN_CLASSROOM);
            setClassroomList(response?.classroomList);
        }
    }, [response])


    const handleToggle = (id) => () => {
    const currentIndex = checked.indexOf(id);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(id);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    };
    
    const handleAddFastQuiz = async ({ idClassroom, idQuiz, quizType }) => {
        const idFastQuiz = await addQuiz({ idClassroom, idQuiz, quizType });
        onSetIdFastQuiz(idFastQuiz);
    }

    const handleAddQuiz = async ({quizType}) => {
        if (checked.length === 0) {
            toast('Seleziona classroom!', {
                icon: '⚠️',
                duration: 5000,
            });
            return;        
        }

        if (checked.length > 1 && quizType===QUIZ_TYPE.FASTQUIZ) {
         toast('Seleziona una sola classroom per creare un quiz rapido!', {
                icon: '⚠️',
                duration: 5000,
            });
            return;
        }

        const checkedClassroomList = checked.map(idClassroom => {
            const checkedClassroom = classroomList.find(({ _id }) => _id === idClassroom);
            if (checkedClassroom) return checkedClassroom;
        })
       
        const idQuiz = await onCreateShareQuiz(checkedClassroomList);
        
        if (checked.length > 0 && idQuiz) {
            checked.map(idClassroom => { 
                if (quizType === QUIZ_TYPE.FASTQUIZ) {                    
                    handleAddFastQuiz({ idClassroom, idQuiz, quizType });
                } 
                if (quizType === QUIZ_TYPE.CLASSROOM) {
                    addQuiz({ idClassroom, idQuiz, quizType });
                }                                
          })
        } 
        navigate('.', { state: { pathNavigate: '/dashboard?tab=classroom' } });
  }

    return (
        <Dialog
            open={isOpen}
        >
            <PopupTitle>
                {classroomList.length === 0 
                    ? <>
                        Non hai ancora classroom,
                        <br />
                        crea quiz personale
                    </>
                    : <>
                        Seleziona classroom per condividere il quiz
                        <br />
                        o crea quiz personale
                    </>
                }
            </PopupTitle>

            <DialogContentStyled>
                <DescriptionStyled>
                    <List>
                        {classroomList.length>0 && !isLoading && classroomList.map(({name, _id: idClassroom}) => {
                            const labelId = name;
                            return (
                                <ListItem
                                    key={idClassroom}
                                    disablePadding
                                >
                                    <ListItemButton role={undefined} onClick={handleToggle(idClassroom)} dense>
                                        <ListItemIcon>
                                            <Checkbox
                                                edge="start"
                                                checked={checked.indexOf(idClassroom) !== -1}
                                                tabIndex={-1}
                                                disableRipple
                                                inputProps={{ 'aria-labelledby': labelId }}
                                            />
                                        </ListItemIcon>
                                        <ListItemText id={labelId} primary={`${name}`} />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                        {isLoading && <Spinner/>}
                    </List>

                </DescriptionStyled>                
            </DialogContentStyled>

            <WrapperActions>
                <WrapperInfo>
                    <NewInfo>Novita! Quiz rapido:</NewInfo>
                    <b>senza registrazione per gli studenti</b>
                </WrapperInfo>
                    <ButtonStyled onClick={()=>handleAddQuiz({quizType:QUIZ_TYPE.FASTQUIZ})} variant='contained' color="benjamin" disabled={isAdditing || classroomList.length===0}>
                        crea quiz rapido
                    </ButtonStyled> 
                    {classroomList.length === 0 &&
                        <div>
                            <InfoFastQuiz>⚠️ Per usare il quiz rapido devi prima creare una classroom.</InfoFastQuiz>
                            <InfoFastQuiz>Vai su <Button component={Link} to='/dashboard'>dashboard</Button> e crea la tua prima classroom.</InfoFastQuiz> 
                        </div>}                
                <ButtonStyled onClick={() => handleAddQuiz({ quizType: QUIZ_TYPE.CLASSROOM })} variant='contained' color="benjamin" disabled={isAdditing || classroomList.length === 0}>
                    crea quiz classroom
                </ButtonStyled>
                <ButtonStyled onClick={onCreatePrivateQuiz} variant='outlined' color='benjamin' >
                   crea quiz personale
                </ButtonStyled>
            </WrapperActions>
        </Dialog>
    );
};